export default __webpack_public_path__ + "static/84bd6bf6a38a0e91dfef27083180ca35.jpg";